{
  "Enter Support Case title": "Titel eingeben",
  "Support Case Title Header": "Titel",
  "Enter product name your enquiry is about": "Produkt (wie NKS, AKS, EKS...)",
  "Product name header": "Produkt",
  "Enter the version of the product you use": "Produktversion",
  "Product version header": "Version",
  "Select the severity of the case": "Schweregrad",
  "Case severity": "Schweregrad",
  "Critical (severity)": "Kritisch",
  "Major (severity)": "Haupt",
  "Normal (severity)": "Normal",
  "Minor (severity)": "Geringfügig",
  "Case status": "Status",
  "Create case": "Fall erstellen",
  "Update case meta": "Aktualisieren",
  "Create new case ...": "Neuer Fall ...",
  "Ask (question)": "Fragen",
  "Support case metadata": "Fallinformationen",
  "Error receiving response for user message": "Fehler beim Empfangen der Antwort auf die Benutzeranfrage",
  "There are no preceding messages to display": "Erstellen Sie einen Support-Fall oder wählen Sie einen aus",
  "Reference document": "Referenzdokument",
  "Conversation": "Unterhaltung",
  "Case history": "Fallhistorie",
  "No conversation to display": "Keine Unterhaltung anzuzeigen",
  "You need to log in to see past cases": "Sie müssen sich anmelden, um frühere Fälle anzuzeigen",
  "Log in to access support case": "Bitte loggen Sie sich ein",
  "Technical support assistant": "Technischer Supportassistent",
  "Cookie consent": "Wir verwenden notwendige Cookies, um unsere Website zu betreiben. Wir möchten zusätzliche Cookies setzen, um die Nutzung der Website zu verstehen, Verbesserungen der Website vorzunehmen und Ihre Einstellungen zu speichern. Wir verwenden auch Cookies, die von anderen Websites gesetzt werden, um Inhalte von deren Diensten bereitzustellen. Lesen Sie unsere Cookie-Benachrichtigung",
  "Accept cookies": "Cookies akzeptieren",
  "Decline cookies": "Ablehnen",
  "Cancel creation": "Erstellung abbrechen",
  "Create new case (modal)": "Neuer Fall",
  "Case created by": "eröffnet von",
  "escalation tag": "Eskalation",
  "Enter the jira project key": "Projektschlüssel für Export",
  "Actions (for Support Case)": "Aktionen",
  "Close case": "Fall schließen",
  "Close and learn case": "Fall schließen und lernen",
  "Delete case": "Fall löschen",
  "Error receiving response for closure": "Fehler beim Empfangen der Antwort auf den Abschluss",
  "Case is closed at": "Fall ist geschlossen am {{ closureTime }}",
  "Jira key missing": "Jira-Schlüssel fehlt",
  "Welcome message": "Willkommen beim Kubernetes-Supportassistenten. Ich werde Sie durch das beste KI-unterstützte Supporterlebnis führen. Bitte beginnen Sie mit der Eingabe Ihrer Frage oder Ihres Problems, bei denen ich Ihnen helfen kann.",
  "Time to respond": "Reaktionszeit",
  "Escalate": "Eskalieren",
  "Open in": "Siehe in ",
  "Case deleted permanently": "Fall dauerhaft gelöscht",
  "organization name: enoventum": "eNoventum Labs Kft.",
  "organization name: metainf": "META-INF Kft.",
  "organization name: testgroup": "Test Group",
  "organization name: rewe": "REWE GROUP",
  "draft kb status": "Entwurf",
  "proposed kb status": "Vorgeschlagen zur Aufnahme in die Wissensdatenbank",
  "published kb status": "Veröffentlicht in der Wissensdatenbank",
  "none kb status": "Keine",
  "Search cases": "Durchsuchen Sie Fälle",
  "Open cases": "Offene Fälle",
  "My cases": "Meine Fälle",
  "Learnt cases": "Gelernte Fälle",
  "Proposed for learning": "Vorgeschlagen zum Lernen",
  "Propose to use learning in future cases": "Vorschlagen, um in zukünftigen Fällen zu lernen",
  "Reject learning": "Lernen ablehnen",
  "Reject learning from the case": "Lernen aus dem Fall ablehnen",
  "Case navigation": "Fallnavigation",
  "Close the case": "Fall schließen",
  "Close and propose for learning": "Schließen und zum Lernen vorschlagen",
  "Automatic selection": "Automatische Auswahl",
  "Close the case and learn from it": "Fall schließen und daraus lernen",
  "workflow_ask": "Problemlösung",
  "workflow_teach": "Lernen",
  "workflow_chit_chat": "Plaudern",
  "workflow_catalogue": "Nur Katalog",
  "Ask a question from Arten": "Stellen Sie Arten eine Frage",
  "Tell Arten a new directive or information to remember": "Teilen Sie Arten eine neue Anweisung oder Information zum Merken mit",
  "Settings": "Einstellungen",
  "Slack Integration": "Slack-Integration",
  "Teams Integration": "Teams-Integration",
  "Click to assign organization": "Klicken, um Organisation zuzuweisen",
  "Not a system administrator": "Kein Systemadministrator",
  "Delete Teams Integration Action": "Löschen",
  "Click to delete integration": "Klicken, um Integration zu löschen",
  "Actions": "Aktionen",
  "Forward case action": "Involvieren Sie den menschlichen Support in den Support-Fall",
  "Close case action": "Fall schließen",
  "Close and learn case action": "Fall schließen und daraus lernen",
  "Close and propose for learning case action": "Fall schließen und zum Lernen vorschlagen",
  "Delete case action": "Fall dauerhaft löschen",
  "Publish learning action": "Schlussfolgerungen für die zukünftige Verwendung ziehen",
  "Reject learning action": "Lernen ablehnen",
  "How can I help user?": "Wie kann ich Ihnen helfen, {{user}}?",
  "More options": "Mehr Optionen",
  "Cases": "Aktuelle Fälle",
  "All cases ...": "Alle Fälle ...",
  "Privacy Policy": "Datenschutz-Bestimmungen",
  "Terms of Service": "Nutzungsbedingungen",
  "Delete": "Löschen",
  "Cancel": "Abbrechen",
  "No recent cases": "Keine aktuellen Fälle",
  "Are you sure you want to delete this case? This action cannot be undone.": "Sind Sie sicher, dass Sie diesen Fall löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
  "Ok": "Ok",
  "Confluence Admin": "Confluence Admin",
  "Documentation": "Dokumentation",
  "Help": "Hilfe",
  "About": "Über",
  "Cancellation warning": "Sie sind dabei, Ihr Abonnement zu kündigen. Diese Aktion wird am Ende des aktuellen Abrechnungszeitraums wirksam. In der Kündigungsfrist sind keine weiteren Überziehungen zulässig. Sie können den Dienst nach dem aktuellen Abrechnungszeitraum nicht mehr nutzen. Sind Sie sicher, dass Sie fortfahren möchten?",
  "Subscription creation confirmation": "Sie sind dabei, den Plan \"{{planName}}\" zu abonnieren. Ihnen werden {{price}} {{currency}} zu Beginn jedes Abrechnungszeitraums in Rechnung gestellt. Dies beinhaltet {{amountIncluded}} Supportfälle. Wenn Sie diese Menge überschreiten, berechnen wir {{overagePrice}} {{currency}} pro zusätzlichem Fall. Sind Sie sicher, dass Sie fortfahren möchten?",
  "Subscription update confirmation": "Sie sind dabei, Ihr Abonnement auf den Plan \"{{planName}}\" zu aktualisieren. Diese Aktion wird sofort wirksam. Ihr aktuelles Abonnement wird gekündigt und Ihre möglicherweise verbleibenden Supportfälle gehen verloren. Ihnen werden {{price}} {{currency}} zu Beginn jedes Abrechnungszeitraums in Rechnung gestellt. Dies beinhaltet {{amountIncluded}} Supportfälle. Wenn Sie diese Menge überschreiten, berechnen wir {{overagePrice}} {{currency}} pro zusätzlichem Fall. Ihr neuer Abrechnungszeitraum beginnt sofort. Sind Sie sicher, dass Sie fortfahren möchten?"
}